// src/components/YourPath/RutasDidacticasEditStep1.js
import React from "react";
import { Form, Button, Dropdown, TextArea } from "semantic-ui-react";
import { useFormik } from "formik";
import { validationSchema } from "../RutasDidacticasForm/RutasDidacticasForm.form";

// Importamos el SCSS que crearemos a continuación
import "./RutasDidacticasEditStep1.scss";

export function RutasDidacticasEditStep1({
  route,
  teacher,
  onUpdateRoute,
  onClose,
  onNext,
}) {
  // Generar opciones de "classNumber" a partir de teacher.classrole
  const classOptions = (teacher?.classrole || []).map((item) => ({
    key: item.classnumber,
    text: item.classnumber,
    value: item.classnumber,
  }));

  // useFormik para manejar el formulario
  const formik = useFormik({
    initialValues: {
      nameRute: route?.nameRute || "",
      description: route?.description || "",
      classnumber: route?.classnumber || "",
    },
    validationSchema: validationSchema(),
    validateOnChange: false,
    // Al hacer submit, solo guardamos los datos y avanzamos
    onSubmit: (values) => {
      // Actualiza la ruta en el Wizard (no llama a la API)
      onUpdateRoute(values);
      onNext();
    },
  });

  return (
    <div className="rutas-step1">
      <h3 className="rutas-step1__title">Editar Itinerario (Datos Generales)</h3>

      <Form onSubmit={formik.handleSubmit} className="rutas-step1__form">
        <Form.Input
          label="Nombre del Itinerario"
          name="nameRute"
          value={formik.values.nameRute}
          onChange={formik.handleChange}
          error={
            formik.errors.nameRute
              ? { content: formik.errors.nameRute, pointing: "above" }
              : null
          }
          className="rutas-step1__field"
        />

        <Form.Field
          control={TextArea}
          label="Descripción"
          name="description"
          value={formik.values.description}
          onChange={formik.handleChange}
          error={
            formik.errors.description
              ? { content: formik.errors.description, pointing: "above" }
              : null
          }
          className="rutas-step1__field"
        />

        <Form.Field error={!!formik.errors.classnumber} className="rutas-step1__field">
          <label className="rutas-step1__label">Módulo o Clase</label>
          <Dropdown
            placeholder="Selecciona un módulo o clase"
            fluid
            selection
            options={classOptions}
            value={formik.values.classnumber}
            onChange={(_, { value }) =>
              formik.setFieldValue("classnumber", value)
            }
            className="rutas-step1__dropdown"
          />
          {formik.errors.classnumber && (
            <div className="rutas-step1__error">
              {formik.errors.classnumber}
            </div>
          )}
        </Form.Field>

        <div className="rutas-step1__buttons">
          <Button type="submit" primary className="rutas-step1__btn">
            Siguiente
          </Button>
          <Button type="button" onClick={onClose} className="rutas-step1__btn">
            Cancelar
          </Button>
        </div>
      </Form>
    </div>
  );
}
